import Confetti from 'react-confetti';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box, Button,
  Container, Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import kami from '../../assets/img/bot-kami.png';
import { setAnalytics } from '../../utils';
import ReturnButton from '../General/ReturnButton';

const useStyles = makeStyles((theme) => ({
  boxPrincipal: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: '10%',
  },
  boxMessage: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    justifyItems: 'center',
  },
  boxButtonBack: {
    margin: theme.spacing(4, 0, 0, 0),
  },
  title: {
    color: theme.palette.text.default,
    fontSize: 35,
    fontFamily: 'Raleway',
  },
  subtitle: {
    color: theme.palette.text.default,
    fontSize: 24,
    fontFamily: 'Raleway',
    margin: 25,
  },
  image: {
    marginRight: 70,
    width: 230,
    transition: 'transform 0.5s linear',
    '&:hover': {
      transform: 'translateY(-30px)',
    },
  },
  containerImg: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonNextTopic: {
    width: 160,
    background: theme.palette.background.secondary,
    color: theme.palette.text.default,
    '&:hover': {
      background: theme.palette.background.secondary,
    },
    fontFamily: 'Raleway',
  },
  containerButton: {
    textAlign: 'center',
  },
  containerTextCourseWithoutReview: {
    maxWidth: 600,
    textAlign: 'center',
    margin: theme.spacing(0, 0, 5, 0),
  },
  textCourseWithoutReview: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    fontSize: 20,
  },
}));

function Finished() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    name, theme, finalCourse, course,
  } = location.state;

  const goToNextTopic = () => {
    setAnalytics('Course', 'Btn_SiguienteTema');
    navigate(`/map/${course}`);
  };

  return (
    <Container>
      {theme && (
        <Confetti
          colors={[
            '#FCD050',
            '#FCD050',
            '#FCD050',
            '#FCD050',
            '#FCD050',
            '#FCD050',
          ]}
          width={window.innerWidth - 2}
          height={window.innerHeight - 10}
        />
      )}
      {finalCourse && (
        <Confetti width={window.innerWidth - 2} height={window.innerHeight - 10} />
      )}
      <Box className={classes.boxButtonBack}>
        <ReturnButton />
      </Box>
      <Box className={classes.boxPrincipal}>
        <Box className={classes.containerImg}>
          <Box
            className={classes.image}
            component="img"
            alt="kami"
            src={kami}
          />
        </Box>
        <Box className={classes.boxMessage}>
          <Typography className={classes.title}>
            {theme ? '¡Felicitaciones! Terminaste con éxito' : null}
            {finalCourse ? '¡Felicitaciones! Terminaste con éxito' : null}
          </Typography>
          <Typography className={classes.subtitle}>
            {theme ? 'TEMA:' : 'CURSO:'}
            {' '}
            {name}
          </Typography>
          <Box>
            {theme ? (
              <Button
                onClick={goToNextTopic}
                variant="contained"
                className={classes.buttonNextTopic}
              >
                Siguiente tema
              </Button>
            ) : null}
            {finalCourse ? (
              <>
                {/* <Typography className={classes.textCourseWithoutReview}>
                {`Ganaste ${koins} koins`}</Typography> */}
                <Box className={classes.containerTextCourseWithoutReview}>
                  <Typography className={classes.textCourseWithoutReview}>
                    Los mentores estarán revisando tu proyecto, en 48 horas
                    máximo te notificaremos el resultado
                  </Typography>
                </Box>
                <Box className={classes.containerButton}>
                  <Button
                    onClick={() => navigate('/home')}
                    className={classes.buttonNextTopic}
                  >
                    Continuar
                  </Button>
                </Box>
              </>
            ) : null}
          </Box>
        </Box>
      </Box>
    </Container>
  );
}

export default Finished;
